import {makeReducer, match} from 'web-app/util/redux';
import {open, close, type ModalState} from 'web-app/react/modals-container/types';

import * as Actions from './actions';

interface BaseState {
    isSubmitting: boolean;
}

export interface ParentState extends BaseState {
    isInternal?: false;
    isAutopayRequired?: boolean;
}

export interface InternalState extends BaseState {
    isInternal: true;
    billPayerId: string;
    onSuccess?: () => void;
}

type State = ParentState | InternalState;

export type AddCardModalState = ModalState<State>;

export default makeReducer<AddCardModalState>(
    [
        match(Actions.show, (_, {payload}) => {
            if (payload.isInternal) {
                return open<State>({
                    isSubmitting: false,
                    isInternal: true,
                    billPayerId: payload.billPayerId,
                    onSuccess: payload.onSuccess,
                });
            }

            return open<State>({
                isSubmitting: false,
                isInternal: false,
                isAutopayRequired: payload.isAutopayRequired,
            });
        }),
        match(Actions.hide, () => {
            return close();
        }),
        match(Actions.startSubmit, state => {
            return {
                ...state,
                isSubmitting: true,
            };
        }),
        match(Actions.stopSubmit, state => {
            return {
                ...state,
                isSubmitting: false,
            };
        }),
    ],
    close(),
);
